import Card from "./Card";
import PersonIcon from "../PersonIcon";
import PropTypes from "prop-types";
import React from 'react';
import {connect} from "react-redux";
import {createDeleteEntityHandler} from "../utils/createDeleteEntityHandler";
import {sharedPortalParents,} from "../../../ducks";

const ParentCard = ({parent, deleteParent}) => {
  return (
    <Card
      icon={() => (<PersonIcon personName={`${parent.first_name} ${parent.last_name}`}/>)}
      editLink={`/parents/${parent.id}`}
      onDelete={() => deleteParent(parent)}
    >
      <div className="sp-profile-card-heading">Contact Information</div>
      <p>
        Email: {parent.email}<br/>
        Phone: {parent.phone_1_number}
      </p>

      <div className="sp-profile-card-heading">Work Information</div>
      <p>
        Occupation/title: {parent.job_title}<br/>
        Employer: {parent.employer}
      </p>
    </Card>
  );
};

ParentCard.propTypes = {
  parent: PropTypes.shape({
    email: PropTypes.string,
    phone_1_number: PropTypes.string,
    job_title: PropTypes.string,
    employer: PropTypes.string,
  }).isRequired
};

const mapDispatchToProps = (dispatch) => ({
  deleteParent: createDeleteEntityHandler({
    dispatch,
    duck: sharedPortalParents,
    confirmMessage: (parent) => `Are you sure you want to delete parent ${parent.first_name} ${parent.last_name}?`,
    successMessage: () => "Parent deleted."
  })
});

export default connect(undefined, mapDispatchToProps)(ParentCard);
